export const FRENCH_LANGUAGE_TEXTS = {
  // Search results
  TIPO_MATERIAL_DELTALLE_TITLE: 'Typologie',
  ACBABADO_DELTALLE_TITLE: 'Finition',
  ESPESOR_MATERIAL_DELTALLE_TITLE: 'Épaisseur',
  COLOR_MATERIAL_DELTALLE_TITLE: 'Couleur',
  RANGO_ANCHO_DELTALLE_TITLE: 'Par Largeur',
  RANGO_ALTO_DELTALLE_TITLE: 'Par Hauteur',
  PIEZAS_DELTALLE_TITLE: 'Pièces',
  NUMERO_LOTE: 'Numero Tranche',
  BLOQUE_TEXT: 'Bloc',
  PAQUETE_TITLE: 'Paquet',
  PAQUETES_TITLE: 'Paquets',
  NO_RESULTS_TITLE: 'Sans Résultat',
  ANCHO_MATERIAL_TITLE: 'Largeur',
  LARGO_MATERIAL_TITLE: 'Longueur', //
  ALTO_MATERIAL_TITLE: 'Hauteur', //
  MEDIDAS_TITLE: 'Format',
  MEDIDAS_ANCHO_TITLE: 'Largeur',
  MEDIDAS_ALTO_TITLE: 'Hauteur',
  SLAB_NUMBER_TITLE: 'Dalle Nº',
  CARGANDO: 'Chargement des données...',
  // filters
  TIPO_MATERIAL_FILTER_TITLE: 'Typologie',
  ACABADO_MATERIAL_FILTER_TITLE: 'Finition',
  ESPESOR_FILTER_TTILE: 'Épaisseur',
  DISPONIBILIDAD_FILTER_TITLE: 'Disponibilité',
  COLOR_MATERIAL_TITLE: 'Couleur',
  USO_MATERIAL_FILTER_TITLE: 'Utilisation',
  ORIGEN_MATERIAL_TITLE: 'Origine',
  RANGO_MEDIDA_FILTER_TITLE: 'Par Taille',
  RANGO_PRECIO_FILTER_TITLE: 'Par Prix',
  // barra filtros
  RESULTS_CONTER_TITLE: 'Resultats',
  BORRAR_FILTROS_TITLE: 'Enlever Filtre',
  FILTERS_BAR_PLACEHOLDER: 'Ajouter Filtre',
  FILTERS_BAR_KEYWORD_PLACEHOLDER: 'Rechercher',
  RANGO_SUPERFICIE_FILTER_TITLE: 'Superficie',
  // detalles
  BOOKMATCH_BUTTON_TEXT: 'Voir Bookmatch',
  // materiales similares
  MATERIALES_SIMILARES_TITLE: 'Produits Similaires',
  // medidas
  CM: 'cm', //
  PULGADAS: 'Inch', //
  METROS: 'Mètres',
  SUPERFICIE: 'Superficie',
  // detalle
  SIMILARES_TITLE: 'Produits Similaires',
  VER_BOOKMATCH: 'Voir Bookmatch',
  FICHA_DATOS: 'FICHE TECHNIQUE',
  SI: 'Oui',
  NO: 'Non',
  ATRAS: 'ARRIÈRE',
  // rango
  A: 'à',
  // menu  
  PRODUCTOS_MENU : 'Produits',
  LIBRARY_MENU : 'Library',
  CATALOGOS_MENU : 'Catalogues',
  SERVICIOS_MENU : 'Services',
  SHOWROOM_MENU : 'Showroom',
  NOSOTROS_MENU : 'Á propos de nous',
  CONTACTO_MENU : 'Nous contacter',
  PRODUCTOS_MENU_LINK : '/fr/produits/',
  CATALOGOS_MENU_LINK : '/fr/catalogues/',
  SERVICIOS_MENU_LINK : '/fr/services/',
  SHOWROOM_MENU_LINK : '/fr/showroom/',
  NOSOTROS_MENU_LINK : '/fr/a-propos-de-nous/',
  CONTACTO_MENU_LINK : '/fr/nous-contacter/'
}
